import React from "react";
import { CommandBarButton, IconButton, Link, SelectionMode } from "@fluentui/react";
import DetailsTable from "../../../Table/DetailsTable";
import FeatureSummary from "../../../Util/FeatureSummary";
import env from "../../../../env";

const { REACT_APP_WWW_BASE_URL } = env;

const CourseTable = ({
    courses,
    setSelectedCourseId,
    setSelectedCourseTitle,
    cloneOnClick,
    loading,
    deleteOnClick,
    editOnClick,
    createOnClick,
    previewOnClick,
    revisionOnClick,
    showRevisions
}) => {
    const columns = [
        {
            key: "column1",
            name: "ID",
            fieldName: "crsid",
            minWidth: 40,
            maxWidth: 40,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            key: "column10",
            name: "Revision",
            fieldName: "revisionNumber",
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
        },
        {
            key: "column2",
            name: "Title",
            fieldName: "title",
            minWidth: 300,
            maxWidth: 420,
            isResizable: true,
            onRender: (item) => (
                <Link href={`${REACT_APP_WWW_BASE_URL}courses/${item.slug}`} target="_blank">{item.title}</Link>
            ),
        },
        {
            key: "menu",
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu
                    editOnClick={editOnClick}
                    cloneOnClick={cloneOnClick}
                    deleteOnClick={deleteOnClick}
                    previewOnClick={previewOnClick}
                    revisionOnClick={revisionOnClick}
                    id={item.crsid}
                    revId={item.crsRevID}
                />
            )
        },
        {
            key: "column3",
            name: "Level",
            fieldName: "level",
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
        },
        {
            key: "column4",
            name: "Category",
            fieldName: "category",
            minWidth: 120,
            maxWidth: 150,
            isResizable: true,
        },
        {
            key: "column5",
            name: "Type",
            fieldName: "type",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
        },
        {
            key: "column10",
            name: "Custom",
            fieldName: "custom",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
        },
        {
            key: "column7",
            name: "Length",
            fieldName: "length",
            minWidth: 70,
            maxWidth: 70,
            isResizable: true,
        },
        {
            key: "column8",
            name: "Status",
            fieldName: "status",
            minWidth: 100,
            maxWidth: 100,
            isResizable: true,
        },
        {
            key: "column9",
            name: "Last Updated",
            fieldName: "lastUpdatedDate",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
        }
    ];

    const items = courses ?? [];

    const selectionHook = (items) => {
        const selectedItem = items && items[0];
        setSelectedCourseId(selectedItem && selectedItem.crsid);
        setSelectedCourseTitle && setSelectedCourseTitle(selectedItem && selectedItem.title);
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns.filter(c => showRevisions || c.name !== "Revision")}
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={"title"}
                detailsListProps={{ selectionMode: SelectionMode.none}}
                style={{
                    position: "relative",
                    height: "80vh",
                    width: "80vw",
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: "Add" }}
                        text="Create Course"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Courses"
                summary="This table displays all courses, including their title, revision, level, category, and type. You can add, edit, clone, or delete courses. The Courses feature allows admins to manage the catalog of educational courses available to users."
                imageUrlPath="courses1"
            />
        </>
    );
};

const moreIcon = { iconName: "More" };

const ContextualMenu = ({
    editOnClick,
    cloneOnClick,
    deleteOnClick,
    revisionOnClick,
    id,
    revId,
    ...rest
}) => {
    const menuProps = {
        items: [
            {
                key: "print",
                iconProps: { iconName: "Edit" },
                text: "Edit",
                onClick: () => editOnClick(id, revId),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id),
            },
            {
                key: "Clone",
                iconProps: { iconName: "Copy" },
                text: "Clone",
                onClick: () => cloneOnClick(id),
            },
            {
                key: "NewRevision",
                iconProps: { iconName: "DoubleColumnEdit" },
                text: "New Revision",
                onClick: () => revisionOnClick(id),
            }
        ],
    };

    return (
        <IconButton
            iconProps={moreIcon}
            menuProps={menuProps}
            onRenderMenuIcon={() => { }}
            {...rest}
        />
    );
};

export default CourseTable;
